import { Spin } from 'antd'

import { ITextarea } from './type'
import css from './index.module.scss'


/** Многострочное текстовое поле  */
export const Textarea = ({ 
    id, name, cols, rows, placeholder, autoComplete = 'off', prefix, suffix, variant = 'primary', width, maxWidth, isReadOnly = false, isDisabled = false, isLoading = false, paddingRight, value, onChange 
}: ITextarea) => {
    return <section className={`${css[variant]} ${isDisabled && css['disabled']}`} style={{ width: width, maxWidth: maxWidth, paddingRight: paddingRight }}>
        {isLoading && <div className={css.isLoading}><Spin size='small' styles={{ indicator: { color: 'var(--color_txt_accent)' } }} /></div>}
        {prefix}
        <textarea id={id} name={name} className={css.textarea} cols={cols} rows={rows} placeholder={placeholder} value={value} onChange={onChange} autoComplete={autoComplete} readOnly={isReadOnly} disabled={isDisabled} style={{ resize: 'none' }} />
        {suffix}
    </section>
}